let activeElement: any;

let handleMenuToggle: Function;

export const setMenuToggleHandler = (menuToggle: Function) => {
	handleMenuToggle = menuToggle;
};

const handleExitByTab = (event: any) => {
	if (activeElement.nextElementSibling === null) {
		activeElement.removeEventListener('blur', handleExitByTab);
		handleMenuToggle(event);
	}
};

const handleExitByShiftTab = (event: any) => {
	if (activeElement.previousElementSibling === null) {
		activeElement.removeEventListener('blur', handleExitByShiftTab);
		handleMenuToggle(event);
	}
};

const handleListMenuExitByTab = (event: any) => {
	if (activeElement.parentElement.nextElementSibling === null) {
		activeElement.removeEventListener('blur', handleListMenuExitByTab);
		handleMenuToggle(event);
	}
};

const handleListMenuExitByShiftTab = (event: any) => {
	if (activeElement.parentElement.previousElementSibling === null) {
		activeElement.removeEventListener('blur', handleListMenuExitByShiftTab);
		handleMenuToggle(event);
	}
};

export const toggleMenuOnTab = (event: any, hasListAsParent: boolean) => {
	if (event.keyCode === 27) {
		handleMenuToggle(event);
	} else if (event.keyCode === 9) {
		activeElement = document.activeElement;
		if (hasListAsParent) {
			activeElement.addEventListener('blur', handleListMenuExitByTab);
		} else {
			activeElement.addEventListener('blur', handleExitByTab);
		}
	}
};

export const toggleMenuOnShiftTab = (event: any, hasListAsParent: boolean) => {
	if (event.shiftKey && event.keyCode === 9) {
		if (activeElement) {
			activeElement.removeEventListener(
				'blur',
				hasListAsParent ? handleListMenuExitByTab : handleExitByTab
			);
			activeElement = document.activeElement;
			activeElement.addEventListener(
				'blur',
				hasListAsParent ? handleListMenuExitByShiftTab : handleExitByShiftTab
			);
		} else {
			handleMenuToggle(event);
		}
	} else if (event.keyCode === 9) {
		if (
			hasListAsParent &&
			//@ts-ignore
			document.activeElement.parentElement.nextElementSibling === null
		) {
			handleMenuToggle(event);
		}
	}
};
